export default function (prefix) {
  return {
    detial: prefix + '/visitorSide/csChannel/detial'
  }
}
